import { render, staticRenderFns } from "./meetRequirements.vue?vue&type=template&id=23cf70c2&"
import script from "./meetRequirements.vue?vue&type=script&lang=js&"
export * from "./meetRequirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports